/** @format */

// NOTE: this keeps the access token in LocalStorage just because it's simpler
// but in a real application you may want to use cookies instead for better security

let loginUrl;

if (process.env.NODE_ENV === 'development') {
  loginUrl = `https://gql.gpson.cz:3000/login`;
} else {
  loginUrl = `https://gql.gpson.cz:3000/login`;
}

class LoginHandler {
  getAccessToken({reset}) {
    let token = localStorage.getItem('accessToken');
    this.accessToken = token;
    return token;
  }

  getEmail() {
    let email = localStorage.getItem('email');
    return email;
  }

  async login(email, password) {
    let that = this;
    const response = await fetch(loginUrl, {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({email, password}),
    });
    if (response.ok) {
      const {token} = await response.json();
      that.accessToken = token;
      that.redirecting = false;
      localStorage.setItem('accessToken', token);
      localStorage.setItem('email', email);
    }
    return response.ok;
  }

  isLoggedIn() {
    return !!localStorage.getItem('accessToken');
  }

  async logout({config, reason} = {}) {
    this.accessToken = null;
    localStorage.removeItem('accessToken');

    if (config && config === 'no-reload') {
      return;
    }
    if (this.redirecting) return;
    this.redirecting = true;
    window.dispatchEvent?.(new Event('gpson-session-ended'));
    const hash = reason === 'session-expired' ? '#/login?reason=session-expired' : '#/';
    const target = (window.location.protocol === 'file:' ? window.location.pathname : '/') + hash;
    // replace()+reload() races when replace starts a cross-document navigation:
    // reload can cancel it and reload the old protected page indefinitely.
    // Commit the same-origin URL synchronously, then reload to clear app memory.
    try {
      window.history.replaceState(null, '', target);
    } catch (_error) {
      window.location.replace(target);
      return;
    }
    window.location.reload();
  }
}

export default LoginHandler;
